export default __webpack_public_path__ + "static/media/ic_venezuela.a51d4a1b.svg";